<template lang="pug">
  .flow-builder-connector-row
    .flow-builder-connector(:class="{editable: !disabled}")
      span.text-sm {{ connectorName }}
      .flow-builder-connector-anchor(v-if="disabled", :id="connectorId", :block_id="block_id", :template_id="template_id", :element_id="element_id")
      block-connector.button-block-connector(v-else, v-bind="$props", button-only, pill, size="sm", @change="updateTemplateConnector")
</template>

<script>
import connectorProps from '@/data/connector-props'
import connectorTypes from '@/data/connector-types'
import _debounce from 'lodash.debounce'

export default {
  mixins: [connectorProps],
  data () {
    return {
      connectorTypes
    }
  },
  computed: {
    connectorName () {
      const type = this.connectorTypes.find(connector => connector.type === this.type)

      return type ? type.name : 'Siguiente bloque'
    }
  },
  created () {
    this.updateTemplateConnector = _debounce(({ attribute, value }) => {
      const connector = JSON.parse(JSON.stringify(this.$props))
      connector[attribute] = value

      this.updateConnector(this.block_id, this.template_id, connector)
    }, 1000, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-connector-row {
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    justify-content: flex-end;
    background-color: transparent;

    &:not(:last-child) {
      margin-bottom: .5rem;
    }

    .flow-builder-connector {
      flex: 0 0 auto;
      border-radius: 7rem;
      background-color: transparent;
      color: $dark;
      text-align: center;
      padding: 5px 5px 5px 10px;
      border: 2px solid $message-bg;
      display: flex;
      align-items: center;

      &:not(.editable) {
        padding: 5px 15px;
      }

      span {
        position: relative;
        width: 100%;
        margin-right: 15px;
      }

      .flow-builder-connector-anchor {
        // position: absolute;
        width: 14px;
        height: 14px;
        // right: 0;
        // top: calc(50% - 6px);
        border-radius: 50px;
      }

      &:not(:last-child) {
        margin-bottom: .5rem;
      }
    }
  }
</style>
